import React from 'react';
import { Helmet } from 'react-helmet';
import baseStyles from '../../theme/base.css';

const Head = () => (
  <Helmet>
    <style>{baseStyles}</style>
  </Helmet>
);
export default Head;
